<template>
	<el-dialog class="clean-message-confirm" :title="title" :visible.sync="visible" width="380px" append-to-body
		:close-on-click-modal="false" @close="onCancel">
		<p>{{ message }}</p>
		<el-checkbox v-model="isCleanMessage">{{ $t('chat.clearChatAlso') }}</el-checkbox>
		<span slot="footer">
			<el-button @click="onCancel">{{ $t('common.cancel') }}</el-button>
			<el-button type="primary" @click="onOk">{{ $t('common.ok') }}</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: 'CleanMessageConfirm',
	data() {
		return {
			visible: false,
			title: '',
			message: '',
			isCleanMessage: true,
			resolve: null,
			reject: null
		}
	},
	methods: {
		open({ title, message }) {
			this.title = title;
			this.message = message;
			this.isCleanMessage = true;
			this.visible = true;
			return new Promise((resolve, reject) => {
				this.resolve = resolve;
				this.reject = reject;
			});
		},
		onOk() {
			this.visible = false;
			this.resolve && this.resolve(this.isCleanMessage);
		},
		onCancel() {
			this.visible = false;
			this.reject && this.reject('cancel');
		}
	}
}
</script>
